'use strict';

const Connection = require('../Connection');
const uuid = require('uuid');

/**
 * Represents an Event in the SDK. It can be sent, subscribed to, and unsubscribed from.
 */
class BaseEvent {
    /**
     * Creates a new instance
     * @param  {String} name Event name
     * @param  {Object} data Event data
     * @return {BaseEvent}      A new instance of BaseEvent
     */
    constructor (name = '', data = {}) {
        this.name = name;
        this.data = data;
        this._generateUniqueId();
        this.callback = () => {};
    }

    /**
     * Sends the event to the server
     * @return {Promise<Object|Error>} A Promise fulfilled with the data coming from the server
     */
    send () {
        return Connection.send(this);
    }

    /**
     * Adds a listener for itself and runs the callback passed as argument
     * @param  {Function} callback Function to run when Event takes place
     */
    subscribe (callback) {
        this.callback = callback;
        return Connection.listen(this.name, this.callback);
    }

    /**
     * Removes the listener set to itself
     */
    unsubscribe (listener) {
        return Connection.removeListener(this.name, listener);
    }

    /**
     * Generates a unique identifier for this event
     * placing it in the event payload
     */
    _generateUniqueId () {
        this.data.eventId = uuid.v4();
    }
}

module.exports = BaseEvent;


// WEBPACK FOOTER //
// ./src/EventTypes/BaseEvent.js